import React, { useEffect, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useSelector } from 'dva';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import {
  CascadeFieldCom,
  SelectFieldCom,
  DatePickerCom,
  TextFieldCom,
} from '../FormType';
import webStorage from '@/utils/storageManager';
import {
  ISHAVEAVALUE,
  NOHAVEAVALUE,
  ISRELATIVE,
  ISABSOLUTE,
  getFetchList,
  checkForm,
  checkTypeStatusThree,
  checkTypeStatusTwo,
  checkTypeStatus,
  getDicListTwo,
  checkConditionOneGroupType,
  getDicList,
  haveFileCodeEnumGroupType,
  oddEvent,
} from '../.././constants';

export default ({
  ruleList = null,
  tagCollectionInfo = null,
  queryType,
  setValue,
  getValues,
  control,
  errors,
  setError,
  clearErrors,
  cLabel,
  pid,
  handleAddRuleData,
  handleAddRuleDataDelete,
  handleAddRuleDetailData,
  handleAddRuleDetailDataDelete,
  handleAddTagRuleData,
  setFieldValueP,
  detailId,
  ruleLabelDirectoryList,
  showButton,
  cascadeCallBack,
}) => {
  const { queryTagOperatorValue, treeTags } = useSelector(
    (state) => state.crowdCreateCopy,
  );
  const dicObj = webStorage.get('DICTOBJ') || {};
  const [number, setNumber] = useState(0);
  useEffect(() => {
    ruleList.forEach((item) => {
      if (item.withinItem) {
        item.withinItem.forEach((it) => {
          if (it.originalDataList) {
            it.originalDataList.forEach((i) => {
              setValue(`tagIds-${i.id}`, i.tagIds);
              setValue(`operation-${i.id}`, i.operation);
              setValue(`operationValue-${i.id}`, i.operationValue);
              setValue(`operationAnd-${i.id}`, i.operationAnd);
              setValue(`operationAndValue-${i.id}`, i.operationAndValue);
              setValue(`operationType-${i.id}`, i.operationType);
            });
          }
        });
      }
    });
  }, [ruleList, setValue, tagCollectionInfo, number]);

  const setFieldValue = (data) => {
    const { self, value } = data; //self =1 点击的第一个级联，self = 2点击的非时间的选择和时间的第二个条件选择，self=3点击的时间的第一个条件
    setFieldValueP(data);

    const today = new Date();
    const date =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();
    if (self === 1) {
      //重置后面所有的值
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationType',
      });
    } else if (self === 2) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 3) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operation',
      });
      setFieldValueP({
        ...data,
        value: value === 3 ? date : '',
        realName: 'operationValue',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAnd',
      });
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    } else if (self === 4) {
      setFieldValueP({
        ...data,
        value: '',
        realName: 'operationAndValue',
      });
    }
    setNumber(number + 1);
  };

  return (
    <Box>
      <Box>
        <Box
          sx={{
            fontSize: '14px',
            color: '#212121',
            fontWeight: '400',
            lineHeight: '20px',
            marginBottom: '8px',
          }}
        >
          {cLabel}{' '}
          <span style={{ color: '#f44336', fontSize: '.75rem' }}>
            {checkForm(ruleList, errors) && '此项有未完成输入或选择项'}
          </span>
          {cLabel === '满足' &&
          errors.tagCollectionRuleIn &&
          !errors.tagCollectionInfo ? (
            <span style={{ color: '#f44336', fontSize: '.75rem' }}>
              此项不能为空
            </span>
          ) : (
            ''
          )}
        </Box>
        {queryType !== 'detail' && (
          <Box sx={{ marginBottom: '25px' }}>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                width: '90px',
                borderRadius: '24px',
                height: '34px',
                marginTop: '6px',
                marginBottom: '6px',
                marginRight: '16px',
              }}
              onClick={() => {
                handleAddRuleData({
                  id: detailId,
                  type: cLabel === '满足',
                  originalDataType: 1,
                });
              }}
            >
              标签
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              sx={{
                width: '90px',
                borderRadius: '24px',
                height: '34px',
                marginTop: '6px',
                marginBottom: '6px',
              }}
              onClick={() => {
                handleAddRuleData({
                  id: detailId,
                  type: cLabel === '满足',
                  originalDataType: 2,
                });
              }}
            >
              人群
            </Button>
          </Box>
        )}
        {ruleList.length > 0 && (
          <Box display="flex">
            <Box display="flex" gap="0 4px">
              <Box
                sx={{
                  fontSize: '14px',
                  color: '#212121',
                  fontWeight: '400',
                  lineHeight: '20px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                或
              </Box>
              <Box sx={{ width: '4px', background: '#1565C0' }}></Box>
            </Box>
            <Box flex="1">
              {ruleList.map((item) => {
                if (item.withinItem && item.withinItem.length > 0) {
                  return (
                    <Box key={item.id} pl={5} width="100%" mb={1}>
                      <Box display="flex" mb={1}>
                        <Box display="flex" gap="0 4px" mr={1}>
                          <Box
                            sx={{
                              fontSize: '14px',
                              color: '#4CAF50',
                              fontWeight: '400',
                              lineHeight: '20px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            且
                          </Box>
                          <Box
                            sx={{ width: '4px', background: '#4CAF50' }}
                          ></Box>
                        </Box>
                        <Box width="100%">
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                          >
                            <Box
                              sx={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px 0',
                              }}
                            >
                              {item.withinItem.map((it) => {
                                if (
                                  it.originalDataList &&
                                  it.originalDataList.length > 0
                                ) {
                                  return (
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                    >
                                      <Box
                                        key={it.id}
                                        sx={{
                                          border: '1px solid #CCCCCC',
                                          borderRadius: '12px',
                                          padding: '0 50px 19px 32px',
                                          position: 'relative',
                                          width: '100%',
                                        }}
                                      >
                                        <Box className="tag-flg-style">
                                          {it.originalDataType === 1
                                            ? '标签'
                                            : '人群'}
                                        </Box>
                                        {it.originalDataList.map((i, inx) => {
                                          if (it.originalDataType === 2) {
                                            return (
                                              <Box
                                                key={i.id}
                                                sx={{
                                                  display: 'flex',
                                                  gap: '0 16px',
                                                  alignItems: 'flex-end',
                                                }}
                                              >
                                                <CascadeFieldCom
                                                  width={300}
                                                  label="请选择人群"
                                                  showLabel={false} //是否需要显示label
                                                  showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                  cascadeData={
                                                    ruleLabelDirectoryList
                                                  }
                                                  queryType={queryType}
                                                  setValue={setValue}
                                                  control={control}
                                                  name={'tagIds-' + i.id}
                                                  realName="tagIds"
                                                  fieldNames={{
                                                    label: 'title',
                                                    value: 'id',
                                                  }}
                                                  nameMessage="人群必选项"
                                                  errors={errors}
                                                  setError={setError}
                                                  clearErrors={clearErrors}
                                                  setFieldValue={setFieldValue}
                                                  isShowSearch={true} //开启搜索
                                                  isDisplayRender={true}
                                                  parameter={{
                                                    tid: item.id,
                                                    wid: it.id,
                                                    pid,
                                                    type: cLabel === '满足',
                                                    selfId: i.id,
                                                    self: 1,
                                                  }}
                                                  rules={{
                                                    validate: () => {
                                                      if (
                                                        !i.tagIds ||
                                                        (Array.isArray(
                                                          i.tagIds,
                                                        ) &&
                                                          i.tagIds.length === 0)
                                                      ) {
                                                        return false;
                                                      }
                                                      return true;
                                                    },
                                                  }}
                                                />
                                                {it.originalDataList.length >
                                                  1 &&
                                                  queryType !== 'detail' && (
                                                    <Box
                                                      display="flex"
                                                      alignItems="flex-end"
                                                    >
                                                      <HighlightOffIcon
                                                        sx={{
                                                          width: '24px',
                                                          height: '24px',
                                                          marginLeft: '18px',
                                                          color:
                                                            'rgba(0, 0, 0, 0.87)',
                                                          cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                          handleAddRuleDetailDataDelete(
                                                            {
                                                              tid: item.id,
                                                              wid: it.id,
                                                              pid,
                                                              type:
                                                                cLabel ===
                                                                '满足',
                                                              selfId: i.id,
                                                            },
                                                          )
                                                        }
                                                      />
                                                    </Box>
                                                  )}
                                                {it.originalDataList.length -
                                                  1 ===
                                                  inx &&
                                                  queryType !== 'detail' && (
                                                    <Box
                                                      sx={{
                                                        width: '35px',
                                                        height: '35px',
                                                        padding: '10px',
                                                        borderRadius: '50%',
                                                        background: '#fafafa',
                                                        boxShadow:
                                                          '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                                                        position: 'absolute',
                                                        right: '12px',
                                                        bottom: '15px',
                                                        cursor: 'pointer',
                                                      }}
                                                      onClick={() =>
                                                        handleAddRuleDetailData(
                                                          {
                                                            tid: item.id,
                                                            wid: it.id,
                                                            pid,
                                                            originalDataType:
                                                              it.originalDataType,
                                                            type:
                                                              cLabel === '满足',
                                                          },
                                                        )
                                                      }
                                                    >
                                                      <AddIcon
                                                        sx={{
                                                          width: '100%',
                                                          height: '100%',
                                                          color:
                                                            'rgba(0, 0, 0, 0.87)',
                                                        }}
                                                      />
                                                    </Box>
                                                  )}
                                              </Box>
                                            );
                                          }
                                          const textIsMultiline =
                                            i.tagIds?.[i.tagIds.length - 1]
                                              ?.ruleType === 2 &&
                                            (i.operation === 5 ||
                                              i.operation === 6);
                                          const selectIsMultiple = [
                                            1, 5,
                                          ].includes(
                                            i.tagIds?.[i.tagIds.length - 1]
                                              ?.ruleType,
                                          );
                                          return (
                                            <Box
                                              key={i.id}
                                              sx={{
                                                display: 'flex',
                                                gap: '0 16px',
                                                alignItems: 'flex-end',
                                              }}
                                            >
                                              <CascadeFieldCom
                                                width={300}
                                                label="请选择标签"
                                                showLabel={false} //是否需要显示label
                                                showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                cascadeData={treeTags}
                                                queryType={queryType}
                                                setValue={setValue}
                                                control={control}
                                                name={'tagIds-' + i.id}
                                                realName="tagIds"
                                                fieldNames={{
                                                  label: 'name',
                                                  value: 'id',
                                                }}
                                                nameMessage="标签目录必选项"
                                                errors={errors}
                                                setError={setError}
                                                clearErrors={clearErrors}
                                                setFieldValue={setFieldValue}
                                                isShowSearch={true} //开启搜索
                                                onCallBack={(e) =>
                                                  cascadeCallBack({
                                                    ...e,
                                                    tid: item.id,
                                                    wid: it.id,
                                                    pid,
                                                    type: cLabel === '满足',
                                                    selfId: i.id,
                                                    self: 1,
                                                  })
                                                }
                                                parameter={{
                                                  tid: item.id,
                                                  wid: it.id,
                                                  pid,
                                                  type: cLabel === '满足',
                                                  selfId: i.id,
                                                  self: 1,
                                                }}
                                                rules={{
                                                  validate: () => {
                                                    if (
                                                      !i.tagIds ||
                                                      (Array.isArray(
                                                        i.tagIds,
                                                      ) &&
                                                        i.tagIds.length === 0)
                                                    ) {
                                                      return false;
                                                    }
                                                    return true;
                                                  },
                                                }}
                                              />
                                              {checkTypeStatus(i.tagIds) &&
                                                !checkTypeStatusTwo(
                                                  i.tagIds,
                                                ) && (
                                                  <Box
                                                    width="109px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <SelectFieldCom
                                                      label="条件"
                                                      placeholder="请选择"
                                                      initLabel=""
                                                      name={'operation-' + i.id}
                                                      realName="operation"
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      getValues={getValues}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      // defaultValue={it?.operation}
                                                      nameMessage=""
                                                      typeList={getDicList(
                                                        i.tagIds,
                                                        dicObj,
                                                      )}
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                        self: 2,
                                                      }}
                                                      fieldNames={{
                                                        label: 'nameZh',
                                                        value: 'dictValue',
                                                      }}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {/*时间的第一个选择*/}
                                              {checkTypeStatus(i.tagIds) &&
                                                checkTypeStatusTwo(
                                                  i.tagIds,
                                                ) && (
                                                  <Box
                                                    width="109px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <SelectFieldCom
                                                      label="条件"
                                                      initLabel=""
                                                      placeholder="请选择"
                                                      name={
                                                        'operationType-' + i.id
                                                      }
                                                      realName="operationType"
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      getValues={getValues}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      nameMessage=""
                                                      // defaultValue={it?.operationType}
                                                      typeList={getDicList(
                                                        i.tagIds,
                                                        dicObj,
                                                      )}
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                        self: 3,
                                                      }}
                                                      fieldNames={{
                                                        label: 'nameZh',
                                                        value: 'dictValue',
                                                      }}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {/*第二个输入框*/}
                                              {!checkTypeStatusTwo(i.tagIds) &&
                                                !checkTypeStatusThree(
                                                  i.tagIds,
                                                ) &&
                                                checkTypeStatus(i.tagIds) &&
                                                i.operation !== ISHAVEAVALUE &&
                                                i.operation !== NOHAVEAVALUE &&
                                                !selectIsMultiple && (
                                                  <Box
                                                    display="flex"
                                                    alignItems="flex-end"
                                                    position="relative"
                                                    bottom={
                                                      queryType !== 'detail'
                                                        ? '-4px'
                                                        : 0
                                                    }
                                                    width="220px"
                                                  >
                                                    <TextFieldCom
                                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                                      initLabel={false} //自定义的label是否显示
                                                      showLabel={false} //是否需要显示label
                                                      placeholder="请输入"
                                                      queryType={queryType} //detail不可编辑用于详情
                                                      helperText="" //用于校验的提醒文字
                                                      name={`operationValue-${i.id}`}
                                                      label="" //label
                                                      control={control}
                                                      errors={errors}
                                                      setValue={setValue}
                                                      isNumber={false}
                                                      isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                                                      isParseInt={false} //true 只能输入正整数，false可以输入小数
                                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                      realName="operationValue"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      multiline={
                                                        textIsMultiline
                                                      }
                                                      minRows={1}
                                                      maxRows={1}
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                      initHeight={{
                                                        height: 'auto',
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {checkConditionOneGroupType(
                                                i.tagIds,
                                              ) &&
                                                selectIsMultiple &&
                                                i.operation !== ISHAVEAVALUE &&
                                                i.operation !==
                                                  NOHAVEAVALUE && (
                                                  <Box
                                                    width="220px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <SelectFieldCom
                                                      label="条件"
                                                      initLabel=""
                                                      placeholder="请选择"
                                                      name={
                                                        'operationValue-' + i.id
                                                      }
                                                      realName="operationValue"
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      getValues={getValues}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      nameMessage=""
                                                      multiple={
                                                        selectIsMultiple
                                                      }
                                                      // defaultValue={it?.operationType}
                                                      typeList={
                                                        haveFileCodeEnumGroupType(
                                                          i.tagIds,
                                                        )
                                                          ? getFetchList(
                                                              i.tagIds,
                                                              queryTagOperatorValue,
                                                            )
                                                          : i.collectArr
                                                      }
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                      fieldNames={
                                                        haveFileCodeEnumGroupType(
                                                          i.tagIds,
                                                        )
                                                          ? {
                                                              label: 'nameZh',
                                                              value:
                                                                'labelCode',
                                                            }
                                                          : {
                                                              label: 'name',
                                                              value: 'id',
                                                            }
                                                      }
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {checkTypeStatusTwo(i.tagIds) &&
                                                i.operationType &&
                                                i.operationType !==
                                                  ISHAVEAVALUE &&
                                                i.operationType !==
                                                  NOHAVEAVALUE && (
                                                  <Box
                                                    width="109px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <SelectFieldCom
                                                      label="日期的第二个条件"
                                                      placeholder="请选择"
                                                      initLabel=""
                                                      name={'operation-' + i.id}
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      getValues={getValues}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      nameMessage="日期的第二个条件"
                                                      // defaultValue={it?.operation}
                                                      typeList={getDicListTwo(
                                                        i,
                                                        dicObj,
                                                        'conditionTwoGroupType',
                                                      )}
                                                      fieldNames={{
                                                        label: 'nameZh',
                                                        value: 'dictValue',
                                                      }}
                                                      realName="operation"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {checkTypeStatusTwo(i.tagIds) &&
                                                i.operationType ===
                                                  ISRELATIVE && (
                                                  <Box
                                                    // width="150px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <DatePickerCom
                                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                      name={
                                                        'operationValue-' + i.id
                                                      }
                                                      showLabel={false}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                      label=""
                                                      defaultValue={
                                                        i.operationValue ??
                                                        new Date()
                                                      }
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      realName="operationValue"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {/*相对时间的第一个输入框*/}
                                              {checkTypeStatusTwo(i.tagIds) &&
                                                i.operationType ===
                                                  ISABSOLUTE && (
                                                  <Box
                                                    width="78px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                    position="relative"
                                                    bottom={
                                                      queryType !== 'detail'
                                                        ? '-4px'
                                                        : 0
                                                    }
                                                  >
                                                    <TextFieldCom
                                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                                      initLabel={false} //自定义的label是否显示
                                                      showLabel={false} //是否需要显示label
                                                      placeholder="请输入"
                                                      queryType={queryType} //detail不可编辑用于详情
                                                      helperText="" //用于校验的提醒文字
                                                      name={`operationValue-${i.id}`}
                                                      label="条件2数值" //label
                                                      endAdornment="天"
                                                      control={control}
                                                      errors={errors}
                                                      setValue={setValue}
                                                      isNumber={true}
                                                      isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                                                      isParseInt={true} //true 只能输入正整数，false可以输入小数
                                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                      initHeight={{
                                                        height: 'auto',
                                                      }}
                                                      realName="operationValue"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {/*相对时间的条件3*/}
                                              {checkTypeStatusTwo(i.tagIds) &&
                                                i.operationType ===
                                                  ISABSOLUTE && (
                                                  <Box
                                                    width="109px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <SelectFieldCom
                                                      label="条件3"
                                                      placeholder="请选择"
                                                      initLabel=""
                                                      name={
                                                        'operationAnd-' + i.id
                                                      }
                                                      queryType={queryType}
                                                      setValue={setValue}
                                                      getValues={getValues}
                                                      control={control}
                                                      errors={errors}
                                                      setError={setError}
                                                      clearErrors={clearErrors}
                                                      nameMessage="条件2必选项"
                                                      // defaultValue={it?.operationAnd}
                                                      // typeList={
                                                      //   dicObj.PROFILE_RELATIVE_DATE_RANGE_OPERATOR
                                                      // }
                                                      typeList={getDicListTwo(
                                                        i,
                                                        dicObj,
                                                        'conditionThreeGroupType',
                                                      )}
                                                      fieldNames={{
                                                        label: 'nameZh',
                                                        value: 'dictValue',
                                                      }}
                                                      realName="operationAnd"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                        self: 4,
                                                      }}
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {checkTypeStatusTwo(i.tagIds) &&
                                                i.operationType ===
                                                  ISABSOLUTE &&
                                                i.operationAnd &&
                                                oddEvent(i.operationAnd, getDicListTwo(
                                                  i,
                                                  dicObj,
                                                  'conditionThreeGroupType',
                                                )) && (
                                                  <Box
                                                    width="78px"
                                                    display="flex"
                                                    alignItems="flex-end"
                                                    position="relative"
                                                    bottom={
                                                      queryType !== 'detail'
                                                        ? '-4px'
                                                        : 0
                                                    }
                                                  >
                                                    <TextFieldCom
                                                      autoFocus={false} //If true, the input element is focused during the first mount.
                                                      initLabel={false} //自定义的label是否显示
                                                      showLabel={false} //是否需要显示label
                                                      placeholder="请输入"
                                                      queryType={queryType} //detail不可编辑用于详情
                                                      helperText="" //用于校验的提醒文字
                                                      name={`operationAndValue-${i.id}`}
                                                      label="条件4数值" //label
                                                      endAdornment="天"
                                                      control={control}
                                                      errors={errors}
                                                      setValue={setValue}
                                                      isNumber={true}
                                                      isPositiveNumber={true} //true 只能输入正数，false可以输入负数
                                                      isParseInt={true} //true 只能输入正整数，false可以输入小数
                                                      showError={false} //false输入框捕获到错误不展示错误样式，默认true
                                                      rules={{
                                                        required: true, //是否是必填项true 必填 false 非必填
                                                      }}
                                                      initHeight={{
                                                        height: 'auto',
                                                      }}
                                                      realName="operationAndValue"
                                                      setFieldValue={
                                                        setFieldValue
                                                      }
                                                      parameter={{
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        type: cLabel === '满足',
                                                        selfId: i.id,
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                              {it.originalDataList.length > 1 &&
                                                queryType !== 'detail' && (
                                                  <Box
                                                    display="flex"
                                                    alignItems="flex-end"
                                                  >
                                                    <HighlightOffIcon
                                                      sx={{
                                                        width: '24px',
                                                        height: '24px',
                                                        marginLeft: '18px',
                                                        color:
                                                          'rgba(0, 0, 0, 0.87)',
                                                        cursor: 'pointer',
                                                      }}
                                                      onClick={() =>
                                                        handleAddRuleDetailDataDelete(
                                                          {
                                                            tid: item.id,
                                                            wid: it.id,
                                                            pid,
                                                            type:
                                                              cLabel === '满足',
                                                            selfId: i.id,
                                                          },
                                                        )
                                                      }
                                                    />
                                                  </Box>
                                                )}
                                              {it.originalDataList.length -
                                                1 ===
                                                inx &&
                                                queryType !== 'detail' && (
                                                  <Box
                                                    sx={{
                                                      width: '35px',
                                                      height: '35px',
                                                      padding: '10px',
                                                      borderRadius: '50%',
                                                      background: '#fafafa',
                                                      boxShadow:
                                                        '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                                                      position: 'absolute',
                                                      right: '12px',
                                                      bottom: '15px',
                                                      cursor: 'pointer',
                                                    }}
                                                    onClick={() =>
                                                      handleAddRuleDetailData({
                                                        tid: item.id,
                                                        wid: it.id,
                                                        pid,
                                                        originalDataType:
                                                          it.originalDataType,
                                                        type: cLabel === '满足',
                                                      })
                                                    }
                                                  >
                                                    <AddIcon
                                                      sx={{
                                                        width: '100%',
                                                        height: '100%',
                                                        color:
                                                          'rgba(0, 0, 0, 0.87)',
                                                      }}
                                                    />
                                                  </Box>
                                                )}
                                            </Box>
                                          );
                                        })}
                                      </Box>
                                      <Box
                                        display="flex"
                                        alignItems="center"
                                        width="60px"
                                        justifyContent="center"
                                      >
                                        {queryType !== 'detail' && (
                                          <HighlightOffIcon
                                            sx={{
                                              width: '24px',
                                              height: '24px',
                                              color: 'rgba(0, 0, 0, 0.87)',
                                              cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                              handleAddRuleDataDelete({
                                                tid: item.id,
                                                wid: it.id,
                                                pid,
                                                type: cLabel === '满足',
                                              });
                                            }}
                                          />
                                        )}
                                      </Box>
                                    </Box>
                                  );
                                }
                                return null;
                              })}
                            </Box>
                          </Box>
                          {queryType !== 'detail' && (
                            <Box>
                              <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                sx={{
                                  width: '90px',
                                  borderRadius: '24px',
                                  height: '34px',
                                  marginTop: '12px',
                                  background: '#4CAF50',
                                  marginRight: '16px',
                                }}
                                onClick={() => {
                                  handleAddTagRuleData({
                                    tid: item.id,
                                    pid,
                                    type: cLabel === '满足',
                                    originalDataType: 1,
                                  });
                                }}
                              >
                                标签
                              </Button>
                              <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                sx={{
                                  width: '90px',
                                  borderRadius: '24px',
                                  height: '34px',
                                  marginTop: '12px',
                                  background: '#4CAF50',
                                }}
                                onClick={() => {
                                  handleAddTagRuleData({
                                    tid: item.id,
                                    pid,
                                    type: cLabel === '满足',
                                    originalDataType: 2,
                                  });
                                }}
                              >
                                人群
                              </Button>
                            </Box>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  );
                }
                return null;
              })}
              {queryType !== 'detail' && showButton !== 'hidden' && (
                <Box pl={5}>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{
                      width: '90px',
                      borderRadius: '24px',
                      height: '34px',
                      marginTop: '12px',
                    }}
                    onClick={() => {
                      handleAddRuleData({
                        id: detailId,
                        type: cLabel === '满足',
                      });
                    }}
                  >
                    添加
                  </Button>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};
